import React from 'react';
import ContentCarousel from './ContentCarousel';

const ContentCarouselWithProps = (props: any) => {
  return (
    <ContentCarousel
      title={props.title}
      contentSlides={props.contentSlides}
      ctaText={props.ctaText}
      ctaLink={props.ctaLink}
    />
  );
};

export default ContentCarouselWithProps;
